// extracted by mini-css-extract-plugin
export default {"top":"CharacterPage_top__SoChJ","sentence":"CharacterPage_sentence__9CjuB","button":"CharacterPage_button__5AhKr","title":"CharacterPage_title__1ItOp"};